import projectsHashes from "Areas/Projects/routesMap.hash";
import { Permissions, security } from "Common/permissions";
import { PageObject, registerRouting, ROUTE_ANCHOR } from "Common/routingUtils";
import DocumentDetails from "./documentDetails";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
if (security.isAllowed([Permissions.DocumentsView])) {
    registerRouting(routingKeys.DOCUMENTS, new PageObject(DocumentDetails, {
        hash: `${projectsHashes.PROJECT_DETAILS}/(?<projectId>(?!0+$)\\d+)/${hashes.DOCUMENTS}`,
        locale: locale.DOCUMENTS
    }, null, false, projectId => {
        if (!Number.isFinite(Number(projectId)) || projectId <= 0)
            return null;
        return `${ROUTE_ANCHOR}${projectsHashes.PROJECT_DETAILS}/${projectId}/${hashes.DOCUMENTS}`;
    }));
}
